export const LANDING = '/';
export const COUNTER = '/view/';
export const SHOP = '/shop/';